import { Link, NavLink } from "react-router-dom";
import { FolderOpen, LayoutDashboard, LogOut, Package, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { InstallAppButton } from "@/components/InstallApp";

const ADMIN_NAV = [["/admin", "Dashboard", LayoutDashboard], ["/clients", "Client Directory", FolderOpen], ["/products", "Products", Package], ["/admin/settings", "Settings", Settings]];

const BottomNav = () => (
  <nav className="admin-bottom-nav no-print lg:hidden" data-testid="admin-bottom-nav">
    {ADMIN_NAV.map(([to, label, Icon]) => (
      <NavLink key={to} to={to} end={to === "/admin"} data-testid={`bottom-nav-${label.split(" ")[0].toLowerCase()}`}
        className={({ isActive }) => `bottom-nav-link ${isActive ? "is-active" : ""}`}>
        <Icon className="h-5 w-5" /><span>{label === "Client Directory" ? "Clients" : label}</span>
      </NavLink>
    ))}
  </nav>
);

export const AppHeader = ({ children }) => {
  const { user, logout } = useAuth() || {};
  return (<>
    <header className="app-header no-print" data-testid="app-header">
      <Link to="/" className="flex items-center gap-3 min-w-0" data-testid="header-home-link">
        <img src="/experior-logo.svg" alt="Experior Financial Group" className="h-10 w-auto shrink-0" />
        <span className="hidden md:block border-l border-slate-200 pl-3 leading-tight">
          <span className="block font-heading font-bold text-[#0b2545] text-[13px]">Experior Financial Group</span>
          <span className="block text-[11px] text-slate-500">Financial Planning Portal · Shalindra K C, ExpInsured Finance</span>
        </span>
      </Link>
      {user?.role === "admin" && (
        <nav className="hidden lg:flex items-center gap-1" data-testid="admin-nav">
          {ADMIN_NAV.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === "/admin"} data-testid={`nav-${label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) => `nav-link ${isActive ? "is-active" : ""}`}>{label}</NavLink>
          ))}
        </nav>
      )}
      <div className="flex items-center gap-2">
        {children}
        {user && <InstallAppButton className="header-install" label="App" />}
        {user && (
          <Button variant="ghost" size="sm" onClick={logout} data-testid="logout-button" className="gap-1.5 text-slate-600">
            <LogOut className="h-4 w-4" /><span className="hidden sm:inline">Sign out</span>
          </Button>
        )}
      </div>
    </header>
    {user?.role === "admin" && <BottomNav />}
  </>);
};
